var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTaxReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 410,
    height: 410,
    viewBox: "0 0 410 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#086eb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1eaaf1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_545",
    x: 0,
    y: 0,
    width: 410,
    height: 410,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_1",
    x: 64,
    y: 30,
    width: 269,
    height: 323,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON:_Tax_Report_-_Large",
    "data-name": "ICON: Tax Report - Large",
    transform: "translate(15 12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -12)",
    filter: "url(#Ellipse_545)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_545-2",
    "data-name": "Ellipse 545",
    cx: 190,
    cy: 190,
    r: 190,
    transform: "translate(15 12)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1922",
    "data-name": "Rectangle 1922",
    width: 255,
    height: 304,
    transform: "translate(68 43)",
    fill: "#9ea3a5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -12)",
    filter: "url(#Subtraction_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1-2",
    "data-name": "Subtraction 1",
    d: "M251,305H56.612L0,249.733V305L0,0H251V305Z",
    transform: "translate(73 42)",
    fill: "#f4f9fc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M0,56.344V0L58.154,56.344Z",
    transform: "translate(117.612 334.052) rotate(180)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M-.694,42.638H14.93V-.211H31.817V-12.6H-17.66V-.211H-.694Zm76.149,0H91.71L67.248-12.6H51.86L27.477,42.638h15.94l4.34-10.732H71.114ZM52.334,20.385l7.1-17.676,7.1,17.676Zm92.878,22.253L124.695,14.072,143.949-12.6H127.062L116.173,3.34,105.125-12.6h-17.6l19.254,27.3L86.66,42.638h17.834l11.284-17.124L127.22,42.638ZM-1.681,82.093H6.684L.726,73.413a9.165,9.165,0,0,0,5.405-8.72c0-6.313-4.735-10.219-12.271-10.219H-18.765V82.093h7.812V74.754h4.261Zm-.079-17.4c0,2.525-1.618,4.024-4.853,4.024h-4.34V60.629h4.34C-3.377,60.629-1.76,62.129-1.76,64.693Zm19.53,11.363v-5.05H30.041V65.167H17.771V60.511H31.7V54.474H10.037V82.093H32.211V76.056ZM48.783,54.474H36.157V82.093h7.812v-7.22h4.814c7.536,0,12.271-3.906,12.271-10.179C61.053,58.38,56.319,54.474,48.783,54.474Zm-.473,14.243h-4.34V60.629h4.34c3.235,0,4.853,1.5,4.853,4.064C53.162,67.218,51.545,68.718,48.309,68.718Zm30.46,13.928c8.838,0,15.348-6.076,15.348-14.362s-6.51-14.362-15.348-14.362S63.421,60,63.421,68.284,69.931,82.645,78.769,82.645Zm0-6.471c-4.182,0-7.457-3.117-7.457-7.891s3.275-7.891,7.457-7.891,7.457,3.117,7.457,7.891S82.951,76.175,78.769,76.175Zm36.141,5.918h8.365l-5.958-8.68a9.165,9.165,0,0,0,5.405-8.72c0-6.313-4.735-10.219-12.271-10.219H97.826V82.093h7.812V74.754H109.9Zm-.079-17.4c0,2.525-1.618,4.024-4.853,4.024h-4.34V60.629h4.34C113.213,60.629,114.831,62.129,114.831,64.693Zm17.281,17.4h7.812V60.669h8.443V54.474H123.63v6.194h8.483Z",
    transform: "translate(123.09 82.021)",
    fill: "#0a579b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1886",
    "data-name": "Group 1886",
    transform: "translate(104.449 182.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_49",
    "data-name": "Line 49",
    d: "M152.109,11.949H4.725a7.225,7.225,0,0,1,0-14.449H152.109a7.225,7.225,0,1,1,0,14.449Z",
    transform: "translate(2.5 2.5)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_49-2",
    "data-name": "Line 49",
    d: "M152.109,11.949H4.725a7.225,7.225,0,0,1,0-14.449H152.109a7.225,7.225,0,1,1,0,14.449Z",
    transform: "translate(2.5 25.619)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_49-3",
    "data-name": "Line 49",
    d: "M152.109,11.949H4.725a7.225,7.225,0,0,1,0-14.449H152.109a7.225,7.225,0,1,1,0,14.449Z",
    transform: "translate(2.5 48.738)",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M78.422,11.949H4.725a7.225,7.225,0,0,1,0-14.449h73.7a7.225,7.225,0,0,1,0,14.449Z",
    transform: "translate(2.5 71.857)",
    fill: "#cfd8dc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaxReport);
export default __webpack_public_path__ + "static/media/icon-tax-report.e6d538a524d0151d3cdd59cdd5dc98fe.svg";
export { ForwardRef as ReactComponent };